export let ToastDuration = {
  Normal: 3000,
  Short: 2000,
}
